import { UseMutationResult, UseQueryResult } from '@tanstack/react-query';

export type UseOrderedProps<K extends Record<string, any>> = {
  userOptionKey: keyof K;
  useQueryHook: () => UseQueryResult<Array<any>, unknown>;
  comparerProp?: string;
  useUserOptionHook: (
    key: keyof K,
    defaultValue: any
  ) => {
    update: UseMutationResult<any, unknown, any, unknown>;
    value: any;
  };
};

export const useOrderedQueryResults = <K extends Record<string, any>>({
  userOptionKey,
  useQueryHook,
  useUserOptionHook,
  comparerProp = 'shortId',
}: UseOrderedProps<K>) => {
  const query = useQueryHook();
  const { value: order } = useUserOptionHook(userOptionKey, []);
  if (query.isLoading) {
    return null;
  }
  const items = [...(query.data ?? [])];
  items.sort((a, b) => {
    const getComparer = (input: K) => {
      const index = order.indexOf(String(input[comparerProp]));
      return index > -1 ? index : Infinity;
    };
    return getComparer(a) - getComparer(b);
  });
  return items;
};
